import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * File upload component with preview and reset functionality.
 * Handles file selection, URL creation, and displays truncated filename.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function FileUpload({ element, parameters, setParameters }) {
  const { t } = useLanguage()

  /**
   * Saves uploaded file and creates object URL for preview.
   * @param {Event} event
   */
  const saveFile = event => {
    if (!setParameters || !element || !event.target.files || !event.target.files[0]) return

    const url = URL.createObjectURL(event.target.files[0])

    setParameters({
      ...(parameters || {}),
      [element.id]: `url(${url})`,
      [`${element.id}_file`]: { path: url, name: event.target.files[0].name },
    })
  }

  /**
   * Truncates filename for display if too long.
   * @param {string} name - File name (nullable)
   * @returns {string} Truncated filename or "No file selected"
   */
  function truncatedFileName(name) {
    if (!name) return t("Icon.iconFileNameText")
    if (name.length <= 20) return name
    const ext = name.includes(".") ? name.substring(name.lastIndexOf(".")) : ""
    const base = name.substring(0, 10)
    const end = name.substring(name.length - 7, name.length - ext.length)
    return `${base}...${end}${ext}`
  }

  const handleReset = () => {
    if (!setParameters || !element) return

    setParameters({
      ...(parameters || {}),
      [element.id]: element.default,
      [`${element.id}_file`]: "",
    })
  }

  const fileName = element && parameters ? parameters[`${element.id}_file`]?.name : null

  return (
    <div className="row fileUpload">
      <div className="col-5">
        {element && <InfoPopover element={element} />}
        <span>{element?.label ? t(element.label) : element?.label}</span>
      </div>
      <div className="col">
        {element && (
          <>
        <input type="file" id={`input-${element?.id}`} onChange={event => saveFile(event)} />
        <label htmlFor={`input-${element?.id}`} className="file-upload-btn" style={{ marginRight: "10px" }}>
          {t("Icon.iconSelectFileButton")}
        </label>
        <span data-testid="file-name">{truncatedFileName(fileName)}</span>
        <div className="resetBloc" style={{ display: "inline-block", verticalAlign: "middle" }} onClick={handleReset} data-testid="reset-button"></div>
          </>
        )}
      </div>
    </div>
  )
}

export default FileUpload
